import { userAppPreferencesDefault } from '../../data/user-app-preferences-default';
import {
    UserAppPreferencesModel
} from '../../models/user-app-preferences.model';

/**
 * Update enableMppEstimates on distributionsPrefs
 */
export function fromOnePointTwoToOnePointThree(oldDataModel: UserAppPreferencesModel): UserAppPreferencesModel {
    const newModel = new UserAppPreferencesModel();
    newModel.version = '1.3';
    newModel.reportsPrefs = oldDataModel.reportsPrefs;
    newModel.targetingPrefs = oldDataModel.targetingPrefs;
    newModel.monitoringPrefs = oldDataModel.monitoringPrefs;

    newModel.targetingPrefs.distributionsPrefs.enableMppEstimates = userAppPreferencesDefault.targetingPrefs.distributionsPrefs.enableMppEstimates;
    return newModel;
}
